import type { OrdersStatisticsQueryParams, OrdersStatisticsResponse } from "@src/types";
import { privateApi } from "./client";

function buildOrdersStatisticsQuery(params: OrdersStatisticsQueryParams): string {
    const search = new URLSearchParams();
    search.set("start_date", params.start_date);
    search.set("end_date", params.end_date);
    search.set("granularity", params.granularity);
    for (const metric of params.metrics) {
        search.append("metrics", metric);
    }

    if (params.delivery_type) {
        search.set("delivery_type", params.delivery_type);
    }

    if (params.pre_order !== undefined && params.pre_order !== null) {
        search.set("pre_order", String(params.pre_order));
    }

    if (params.status) {
        search.set("status", params.status);
    }

    if (params.merchant_id) {
        search.set("merchant_id", params.merchant_id);
    }

    return search.toString();
}

export async function getOrdersStatisticsApi(
    params: OrdersStatisticsQueryParams,
    signal?: AbortSignal,
): Promise<OrdersStatisticsResponse> {
    const query = buildOrdersStatisticsQuery(params);
    const endpoint = `/api/orders/statistics?${query}`;
    const { data } = await privateApi.get<OrdersStatisticsResponse>(endpoint, { signal });
    return data;
}
